var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSterringWheel = function SvgIconSterringWheel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6217_12956)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9515 2.57324C29.8392 2.57324 37.868 10.602 37.868 20.4906C37.868 30.3791 29.8392 38.4071 19.9515 38.4071C10.063 38.4071 2.03418 30.3791 2.03418 20.4906C2.03418 10.602 10.063 2.57324 19.9515 2.57324ZM19.9515 17.157C18.1114 17.157 16.618 18.6505 16.618 20.4906C16.618 22.3298 18.1114 23.8233 19.9515 23.8233C21.7907 23.8233 23.2842 22.3298 23.2842 20.4906C23.2842 18.6505 21.7907 17.157 19.9515 17.157ZM6.49576 23.3329C7.64089 28.7718 12.0058 33.0314 17.4995 34.0217V27.5C17.4909 23.344 12.4996 23.3329 12.4996 23.3329H6.49576ZM33.5331 18.3355C32.4975 11.7686 26.8069 6.74041 19.9515 6.74041C13.0953 6.74041 7.40467 11.7686 6.36909 18.3355C7.99778 18.3373 10.627 18.3398 11.666 18.333C13.3871 18.3218 15.5516 16.3397 16.618 15.833C18.417 14.978 19.9994 14.9994 19.9994 14.9994C19.9994 14.9994 21.5828 14.978 23.3818 15.833C24.4473 16.3397 26.6118 18.3218 28.3329 18.333C29.3522 18.339 31.8984 18.3373 33.5331 18.3355ZM22.4994 34.0037C27.9478 32.9809 32.2681 28.7402 33.4064 23.3329H27.4993C27.4993 23.3329 22.508 23.344 22.4994 27.5V34.0037Z",
    fill: "#3E47DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6217_12956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
};
export default SvgIconSterringWheel;